<template>
    <Modal>
        <div v-if="emailSent" class="text-center font-italic my-5">{{ $t('checkEmail') }}</div>

        <div v-else-if="passwordRequestSubmitted" class="text-center font-italic my-5">
            {{ $t('passwordRequestSubmitted') }}
        </div>

        <form v-else @submit="passwordResetSubmitted" method="post" class="m-4">

            <div v-if="loading" class="row justify-content-center position-absolute pt-3" style="left: 0; right: 0">
                <div
                        class="spinner-border"
                        role="status"
                        style="width: 10rem; height: 10rem; z-index: 1"
                ></div>
            </div>

            <div class="row font-italic">
                {{ $t('enterEmailToResetPassword') }}
            </div>

            <div class="row justify-content-center py-4">
                <label for="email" class="sr-only">
                    Email
                </label>
                <input
                        type="email"
                        id="email"
                        autocomplete="off"
                        class="form-control form-control-lg col"
                        :disabled="loading || this.resetToken"
                        v-model="email"
                        :placeholder="this.$t('email')"
                >
            </div>

            <div v-if="this.resetToken">
                <div class="row justify-content-center py-4">
                    <label for="newPassword" class="sr-only">
                        New Password
                    </label>
                    <input
                            type="password"
                            id="newPassword"
                            autocomplete="off"
                            class="form-control form-control-lg col"
                            :disabled="loading"
                            v-model="newPassword"
                            :placeholder="this.$t('newPassword')"
                    >
                </div>

                <div class="row justify-content-center py-4">
                    <label for="newPasswordRepeated" class="sr-only">
                        New Password (Again)
                    </label>
                    <input
                            type="password"
                            id="newPasswordRepeated"
                            class="form-control form-control-lg col"
                            :disabled="loading"
                            v-model="newPasswordRepeated"
                            :placeholder="this.$t('confirmPassword')"
                    >
                </div>
            </div>

            <div class="row py-4">
                <div :hidden="!errors" class="text-danger font-italic" v-for="(error, index) in errors" :key="index">
                    {{ error }}
                </div>
            </div>

            <div class="row justify-content-end align-items-center py-4">
                <button
                        type="submit"
                        id="login"
                        :disabled="shouldDisableResetButton"
                        class="btn btn-primary col-6">
                    {{ $t('reset') }}
                </button>
            </div>
        </form>
    </Modal>
</template>

<script>
    import Modal from "../Shared/Modal";
    import axios from "axios";

    export default {
        components: {
            Modal
        },
        data() {
            return {
                emailSent: false,
                passwordRequestSubmitted: false,
                loading: false,
                errors: [],
                email: null,
                newPassword: "",
                newPasswordRepeated: ""
            };
        },
        created() {
            this.email = this.$route.query.email;

            if (this.email) {
                this.passwordResetSubmitted();
            }
        },
        methods: {
            changePassword() {
                const resetTokenChangePasswordRequest = {
                    email: this.email,
                    token: this.resetToken,
                    newPassword: this.newPassword
                };

                axios.post('/api/v4/auth/reset', resetTokenChangePasswordRequest)
                    .then(() => {
                        this.passwordRequestSubmitted = true;
                        setTimeout(() => this.$router.push('/login'), 5000);
                    })
                    .catch(errorResponse => {
                        this.responses = [];
                        errorResponse.response.data.forEach(error => this.errors.push(this.$t(error.code)));
                    })
                    .then(() => this.loading = false);
            },
            requestResetToken() {
                const resetTokenChangePasswordRequest = {
                    email: this.email
                };

                axios.post('/api/v4/auth/reset', resetTokenChangePasswordRequest)
                    .then(() => this.emailSent = true)
                    .catch(() => this.errors = [this.$t("somethingWentWrong")])
                    .then(() => this.loading = false);
            },
            passwordResetSubmitted: function (event) {
                event && event.preventDefault();

                this.loading = true;

                if (this.resetToken) {
                    this.changePassword();
                } else {
                    this.requestResetToken();
                }
            },
        },
        computed: {
            resetToken() {
                return this.$route.query.reset_token;
            },
            newPasswordNotRepeated() {
                return !this.newPassword || !this.newPasswordRepeated || this.newPassword !== this.newPasswordRepeated;
            },
            shouldDisableResetButton() {
                if (this.resetToken) {
                    return this.newPasswordNotRepeated && !!this.email;
                }

                return !this.email;
            }
        }
    }
</script>

<style lang="scss">
    @import '~bootstrap/scss/bootstrap';
</style>

<i18n lang="yaml" locale="en">
    enterEmailToResetPassword: "Please enter your email to receive a link to reset your password."
    checkEmail: "Check your email for further instructions on how to reset your password."
    passwordRequestSubmitted: "Password changed successfully. You will now be redirected to the login page..."
    newPassword: "New Password"
    confirmPassword: "Confirm Password"
</i18n>

<i18n lang="yaml" locale="dk">
    enterEmailToResetPassword: "Indtast venligst din e-mail for at modtage et link til nulstilling af din adgangskode."
    checkEmail: "Kontroller din mail for yderligere instruktioner."
    passwordRequestSubmitted: "Adgangskoden blev ændret. Du bliver nu omdirigeret til login-siden..."
    newPassword: "Ny Adgangskode"
    confirmPassword: "Bekræft adgangskode"
</i18n>
